// extracted by mini-css-extract-plugin
export default {"root":"interaction-icon_root__Hfi8r","skeleton":"interaction-icon_skeleton__8po4Z","iconWrapper":"interaction-icon_iconWrapper__hhZ7z"};